import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@/utils/httpClient';

export interface TopLocation {
  location_id: string;
  location_name: string;
  breadcrumb: string;
  asset_count: number;
  asset_value: number;
}

export interface LevelLabels {
  root_label: string | null;
  level1_label: string | null;
  leaf_label: string | null;
}

export interface LocationIemMetrics {
  total_locations: number;
  locations_with_stock: number;
  empty_locations: number;
  total_asset_count: number;
  total_asset_value: number;
  avg_assets_per_location: number;
  top_locations: TopLocation[];
  level_labels: LevelLabels;
}

/**
 * Fetches aggregated location IEM metrics for the dashboard.
 * Returns location counts, stock distribution, and top locations.
 */
export const useLocationMetrics = (enabled = true) => {
  return useQuery({
    queryKey: ['location-iem-metrics'],
    queryFn: async (): Promise<LocationIemMetrics> => {
      const result = await httpClient.get<LocationIemMetrics[]>('/api/v1/location_iem_metrics');
      const row = result?.[0];
      if (!row) {
        return {
          total_locations: 0,
          locations_with_stock: 0,
          empty_locations: 0,
          total_asset_count: 0,
          total_asset_value: 0,
          avg_assets_per_location: 0,
          top_locations: [],
          level_labels: { root_label: null, level1_label: null, leaf_label: null },
        };
      }
      return row;
    },
    enabled,
    staleTime: 60 * 1000,
  });
};
